import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { passwordPattern } from "../../Config/Regex";
import { globalServices } from "../../Services/global.service";

const ChangePassModal = ({ show, handleClose }) => {
  const { t: translator } = useTranslation();
  const [passType, setPassType] = useState("password");
  const [resultMsg, setResultMsg] = useState("");

  const { register, handleSubmit, errors, control } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    return () => {
      setResultMsg("");
    };
  }, [show]);

  const handleChangePass = (data) => {
    globalServices
      .changePassword(data)
      .then((res) =>
        res.data.success
          ? setResultMsg("ChangePass-Success")
          : setResultMsg("Recover-Password-Error")
      )
      .catch((err) => console.log(err));
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{translator("ChangePass")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="container-fluid">
          <div className="form-group">
            <label>{translator("ChangePass-OldPass")}*</label>
            <input
              name="oldPassword"
              ref={register({ required: true })}
              control={control}
              className="form-control"
              type="text"
            />
          </div>
          <div className="form-group">
            <label>{translator("ChangePass-NewPass")}*</label>
            <input
              name="newPassword"
              className="form-control"
              ref={register({ required: true, pattern: passwordPattern })}
              control={control}
              type={passType}
            />
            <span
              className="change-pass-eye"
              onMouseDown={() => setPassType("text")}
              onMouseUp={() => setPassType("password")}
              onMouseLeave={() => setPassType("password")}
              onTouchStart={() => setPassType("text")}
              onTouchCancel={() => setPassType("password")}
            >
              <i className="fas fa-eye text-dark"></i>
            </span>
          </div>
          <div className="form-group">
            <label>{translator("ChangePass-ConfirmPass")}*</label>
            <input
              name="confirmPassword"
              className="form-control"
              ref={register({ required: true, pattern: passwordPattern })}
              control={control}
              type={passType}
            />
            <span
              className="change-pass-eye-two"
              onMouseDown={() => setPassType("text")}
              onMouseUp={() => setPassType("password")}
              onMouseLeave={() => setPassType("password")}
              onTouchStart={() => setPassType("text")}
              onTouchCancel={() => setPassType("password")}
            >
              <i className="fas fa-eye text-dark"></i>
            </span>
          </div>
          {errors.newPassword && errors.newPassword.type === "pattern" && (
            <p className="text-danger">
              {translator("ValidationMsg-PasswordPattern")}
            </p>
          )}
          {errors.confirmPassword &&
            errors.confirmPassword.type === "pattern" && (
              <p className="text-danger">
                {translator("ValidationMsg-PasswordPattern")}
              </p>
            )}
          {<p>{resultMsg}</p>}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={handleClose}
          type="button"
          className="btn btn-outline-secondary"
        >
          {translator("ResultModal-Close-Btn")}
        </button>
        <button
          onClick={handleSubmit(handleChangePass)}
          type="button"
          className="btn btn-primary"
        >
          {translator("Confirm")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePassModal;
